export default __webpack_public_path__ + "static/media/wallet.daf2f763.svg";